// extracted by mini-css-extract-plugin
export default {"imageContainer":"WelcomeSection_imageContainer__1R1Uq","imageSelectorBtn":"WelcomeSection_imageSelectorBtn__XWesa","imageSaveBtn":"WelcomeSection_imageSaveBtn__MgK4b"};